import { PATHS } from "router/paths";

export const uploadRegex = /\/upload\/\d+/;
export const tokensRegex = /\/tokens\/\d+/;
export const usersRegex = /\/tokens\/\d+/;

export const routesConfig = () => {
  return [
    { path: PATHS.HOME, regex: uploadRegex, message: "Upload Recalls", defaultClassname: "Upload-Recalls" },
    { path: PATHS.UPLOAD, regex: uploadRegex, message: "Upload Recalls", defaultClassname: "Upload-Recalls" },
    {
      path: PATHS.GENERATE_RECALL_TOKENS,
      regex: tokensRegex,
      message: "Generate Recall Tokens",
      defaultClassname: "Generate-Recall-Tokens"
    },
    {
      path: PATHS.USERS,
      regex: usersRegex,
      message: "Users",
      defaultClassname: "Users"
    }
  ];
};

export const getRouteProperties = (location: any) => {
  for (const { path, regex, message, defaultClassname } of routesConfig()) {
    if (location.pathname === path || (regex && regex.test(location.pathname))) {
      return {
        title: <>{message && <h4>{message}</h4>}</>,
        defaultClassname: defaultClassname
      };
    }
  }

  return {
    title: <h4>Recalls</h4>,
    defaultClassname: "Recalls-Dashboard"
  };
};
